import * as React from 'react';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetTranslations } from '@/generated/translations';
import { ArrowButton } from '../ArrowButton';
import { DotButton } from '../DotButton';
import { Carousel, CarouselProps } from './Carousel';

export const carouselGapSizes = ['sm', 'md', 'none'] as const;
export type CarouselGapSize = (typeof carouselGapSizes)[number];

/**
 * Generic Carousel component, used for showing slides of any kind of content.
 * Used e.g. in CMS context.
 */
export const CarouselWithOverrides: React.FC<CarouselProps> = (props) => {
	const { segmentationId } = React.useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);

	return (
		<Carousel
			{...props}
			sliderLabel={translations?.data.shared.navigation.slider}
			ArrowButton={ArrowButton}
			DotButton={DotButton}
		/>
	);
};
